import styles from './TextArea.module.css';
import { classList } from '../../helpers/classList';
import { FormLabel } from '../FormLabel';
import { FieldError } from '../FieldError';

export interface TextAreaProps {
  state?: 'normal' | 'valid' | 'error';
  className?: string;
  label?: string;
  description?: string | React.ReactNode;
  placeholder?: string;
  id?: string;
  name?: string;
  required?: boolean;
  value?: string;
  cols?: number;
  rows?: number;
  minLength?: number;
  maxLength?: number;
  readOnly?: boolean;
  disabled?: boolean;
  error?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
}

export const TextArea = (props: TextAreaProps) => {
  // possible visual states: ['normal' or undefined, 'valid', 'error']
  const state = props.state && props.state != 'normal' ? props.state : undefined;

  return (
    <div className={props.className}>
      <FormLabel htmlFor={props.id} required={props.required}>
        {props.label}
      </FormLabel>
      {props.description && <p className='description'>{props.description}</p>}
      <div className={classList(styles['input-container'], state ? styles[`input-container-${state}`] : undefined)}>
        <textarea
          className={classList(styles.input, state ? styles[`input-${state}`] : undefined)}
          id={props.id}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          cols={props.cols}
          rows={props.rows}
          minLength={props.minLength}
          maxLength={props.maxLength}
          readOnly={props.readOnly}
          disabled={props.disabled}
          onChange={props.onChange}
          onBlur={props.onBlur}
        />
      </div>
      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
